<template>
  <div class="search-bar">
    
    <el-input
      class="normal"
      v-model="filter"
      v-if="!isAdvance"
      clearable
      @clear="handleSearch"
      @keyup.enter.native="handleSearch"
      @change="handleChange">
    </el-input>    
    <WAdvancedSearch 
      v-if="isAdvance"
      ref="advanced-search"
      :allTableHeaders="header"/>    
    <el-button
      type="primary"
      @click="isAdvance=!isAdvance"
      >
      <svg-icon style="width:11px;height:11px;margin-right:5px" icon-class="advance"></svg-icon>
      {{!isAdvance?$t('buttons.advance'):$t('buttons.common')}}
    </el-button>
    <el-button 
      style="margin-right:10px"
      type="primary" 
      icon="el-icon-search"
      @click="handleSearch"
    >
      搜索
    </el-button>
  </div>
</template>

<script>
import WAdvancedSearch from './WAdvancedSearch'
export default {
  name: 'SearchBarAd',
  components: {
    WAdvancedSearch
  },
  model: {
    prop: 'value', // 要存在于props
    event: 'change'// 当组件的值发生改变时要emit的事件名
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    header: {
      type: Array,
      required: true
    }
  },
  watch: {
    value(val) {
      this.$nextTick(() => {
        this.filter = val
      })
    },
    isAdvance() {
      this.$nextTick(() => {
        this.filter = ''
        this.$emit('change', '')
      })
    }
  },
  data() {
    return {
      reg: RegExp(/[(\%)(\^)(\_)(\[)(\])]+/),
      filter: this.value,
      isAdvance: false
    }
  },
  methods: {
    handleSearch() {
      if (this.isAdvance) {
        const arr = this.$refs['advanced-search'].showList
        const filterArr = []
        arr.map(a => {
          const prop = +a.column
          let filter = ''
          if (typeof (a.filter) === 'string' || typeof (a.filter) === 'number' || typeof (a.filter) === 'boolean') {
            filter = this.reg.test(a.filter) ? `like` : `equals`
            filterArr.push({ id: prop, op: filter, v: a.filter, t: a.baseType })
          } else {
            filterArr.push({ id: prop, op: 'before', v: a.filter[0], t: a.baseType })
            filterArr.push({ id: prop, op: 'after', v: a.filter[1], t: a.baseType })
          }
        })
        this.$emit('handleSearch', this.isAdvance, JSON.stringify(filterArr))
      } else {
        this.$emit('handleSearch', this.isAdvance)
      }
    },
    handleChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>
<style lang="scss">
  .search-bar{
    float: right;
    .el-input{
      .el-input__inner{
        height: 33px;
        line-height: 33px;
      }
    }
    .el-button{
      float: right;
    }
  }

</style>